import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _fragment_AtlassianUiModificationsCore_RootFragment from "./__generated__/fragment_AtlassianUiModificationsCore_RootFragment.graphql";
import React from 'react';
import { di } from 'react-magnetic-di';
import { graphql, useFragment } from 'react-relay';
import { AppsRenderer } from './apps-renderer';
import { useAppsToRender } from './apps-renderer/use-apps-to-render';
import { useContextCleanup } from './use-contexts-cleanup';
var useEnrichedExecutionContext = function useEnrichedExecutionContext(_ref) {
  var executionContext = _ref.executionContext;
  // const viewType = useViewType();

  return executionContext && _objectSpread(_objectSpread({}, executionContext), {}, {
    viewType: 'JSMRquestCreate' // TODO: replace with actual view type
  });
};

/**
 * UI modifications root component with Relay fragment.
 *
 * The purpose is to use it as a part of a parent query.
 */
export var UiModificationsRootFragment = function UiModificationsRootFragment(props) {
  var executionContext = useEnrichedExecutionContext({
    executionContext: props.executionContext
  });
  var executionContextKey = props.executionContextKey;

  // TODO: Add checks
  // isTriggerPointSupported, needed when Relay fragement is used directely
  // isExecutionContextSupported, for e.g project type check
  if (!executionContext || !executionContextKey) {
    return null;
  }

  // TODO: pass tenantContext and executionContext by React context
  return /*#__PURE__*/React.createElement(RootFragmentWithCleanup, _extends({}, props, {
    executionContext: executionContext,
    executionContextKey: executionContextKey
  }));
};

/**
 * It is separated from
 * - `UiModificationsRootFragment` to run cleanup only when we know that we want to render UIM
 * - `RootFragment` to run cleanup imidiately without awaiting for the new Relay data when context changed
 */
var RootFragmentWithCleanup = function RootFragmentWithCleanup(props) {
  useContextCleanup({
    executionContextKey: props.executionContextKey
  });
  return /*#__PURE__*/React.createElement(RootFragment, props);
};
var RootFragment = function RootFragment(_ref2) {
  var fragmentRef = _ref2.fragmentRef;
  var response = useFragment( /* eslint-disable @atlassian/relay/unused-fields */_fragment_AtlassianUiModificationsCore_RootFragment, /* eslint-enable @atlassian/relay/unused-fields */
  fragmentRef);
  var appsToRender = useAppsToRender(response);
  return /*#__PURE__*/React.createElement(AppsRenderer, {
    apps: appsToRender
  });
};